import {
  deleteAdminV1StoresStoreIdMarketsId,
  getAdminV1OrgExchangeRates,
  getAdminV1StoresStoreIdMarkets,
  patchAdminV1StoresStoreIdMarketsId,
  postAdminV1StoresStoreIdMarkets,
  type ExchangeRate,
  type Market,
  type PatchAdminV1StoresStoreIdMarketsIdBody,
  type PostAdminV1StoresStoreIdMarketsBody,
} from '@nucleus-commerce/api-client/admin';

/** Markets of one store: a bounded `{ items }` list, default first, no cursor. */
export const marketsApi = {
  list: (storeId: string): Promise<Market[]> =>
    getAdminV1StoresStoreIdMarkets({ storeId }).then((r) => r.items),
  create: (storeId: string, body: PostAdminV1StoresStoreIdMarketsBody): Promise<Market> =>
    postAdminV1StoresStoreIdMarkets({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdMarketsIdBody,
  ): Promise<Market> => patchAdminV1StoresStoreIdMarketsId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdMarketsId({ storeId, id }),
  /** Platform-maintained rates; tenants only read them. */
  exchangeRates: (): Promise<ExchangeRate[]> => getAdminV1OrgExchangeRates().then((r) => r.items),
};
